export default __webpack_public_path__ + "static/media/home-icon.80f1ac6b.svg";